export default "__VITE_ASSET__9s6ZP2pU__"